export const SOCKETIO_CONFIG = {
  domain: 'https://api.ssr-leiden.nl/',
  path: '/teller/socket.io'
}

export const AUTH0_CONFIG = {
  clientId: '8kKMEBVxmD6AD76ZaW91oCrDy9xpXR3Y',
  domain: 'jvsomeren.eu.auth0.com',
  callbackUrl: `${window.location.href}`
}



// WEBPACK FOOTER //
// ./src/config.js